<template>
  <v-col :lg="card_size" sm="6" md="7" cols="12">
    <v-card>
      <v-card-title class="pa-6 pb-3">
        <div>{{ title }}</div>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-6 pt-0">
        <v-row no-gutters>
          <v-col cols="6" class="my-auto">
            <span class="" :style="{ 'font-size': text_font_size }"
              >{{ title_number }}
            </span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-icon :color="card_icon_color" size="70">{{ card_icon }}</v-icon>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ApexChart from "vue-apexcharts";

@Component({
  components: { ApexChart },
})
export default class DashboardCardStats extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly title_number: string;
  @Prop() readonly card_icon: string;
  @Prop() readonly card_icon_color: string;
  @Prop() readonly text_font_size: string;
  @Prop({default: 3}) readonly card_size: string;
}
</script>

<style lang="scss">
@import "../../styles/app";

.dashboard-page {
  .page-title {
    padding-bottom: 20px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
  }
  .apexcharts-legend-series {
    padding: 2px 5px 3px;
    display: flex;
    align-items: center;
    .apexcharts-legend-marker {
      margin-right: 8px;
    }
  }
  .main-chart-select {
    font-size: 1rem;
    margin-right: 10px;
    fieldset {
      border-width: 1px !important;
      border-color: $text-grey !important;
      color: $text-grey !important;
    }
    .v-select__selection {
      color: $text-color !important;
    }
  }
  .v-card {
    height: 100%;
    .v-card__text {
      .subtext {
        font-size: 1.142rem;
        font-weight: 400;
        color: $title-grey;
      }
      .subtext-index {
        font-size: 11px;
        color: $text-color;
        font-weight: 400;
      }
    }
  }
}

.v-menu__content {
  box-shadow: $card-shadow !important;
  .v-list-item__content .v-list-item__title {
    font-size: 1rem;
    font-weight: 400;
  }
}
.button-shadow {
  box-shadow: $button-shadow;
}
</style>
